import React from "react";
import type {
  AccruedPensions,
  IndexData,
  PensionEstimate,
  YearConstants,
} from "../types/Codes";
import type { I18n } from "../types/I18n";
import type { ValueLabel } from "../types/ValueLabel";

interface ContextData {
  readonly industries?: ValueLabel<string, I18n>[];
  readonly yearConstants?: YearConstants[];
  readonly pensionEstimate?: PensionEstimate[];
  readonly index?: IndexData[];
  readonly accruedPensions?: AccruedPensions[];
}

const CodesContext = React.createContext<ContextData>({
  industries: [],
  yearConstants: [],
  pensionEstimate: [],
  index: [],
  accruedPensions: [],
});

export default CodesContext;
